import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { navLinks } from '../data/mockData';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    setIsMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled
            ? 'bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg shadow-black/20 py-3'
            : 'bg-transparent py-5'
        }`}
      >
        <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
          <a
            href="#inicio"
            onClick={(e) => { e.preventDefault(); scrollToSection('#inicio'); }}
            className="font-display text-xl md:text-2xl font-bold text-white tracking-wide"
          >
            Buffet{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#8B6F47] to-[#C9A961]">
              MultiEventos
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); scrollToSection(link.href); }}
                className="font-body text-xs tracking-[0.2em] uppercase text-white/70 hover:text-[#C9A961] transition-colors duration-300"
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href="https://wa.me/5531999172997"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-gradient-to-r from-[#8B6F47] to-[#C9A961] text-white font-body text-xs font-semibold tracking-[0.1em] uppercase px-6 py-2.5 rounded-sm hover:opacity-90 transition-opacity"
            >
              <Phone className="w-3.5 h-3.5" />
              Fale Conosco
            </a>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="lg:hidden text-white p-2"
          >
            {isMobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-[#0a0a0a]/98 backdrop-blur-lg transition-all duration-500 lg:hidden ${
          isMobileOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="flex flex-col items-center justify-center h-full gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); scrollToSection(link.href); }}
              className="font-display text-2xl text-white/80 hover:text-[#C9A961] transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://wa.me/5531999172997"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 flex items-center gap-2 bg-gradient-to-r from-[#8B6F47] to-[#C9A961] text-white font-body text-sm font-semibold tracking-[0.1em] uppercase px-8 py-3 rounded-sm"
          >
            <Phone className="w-4 h-4" />
            Fale Conosco
          </a>
        </div>
      </div>
    </>
  );
};

export default Navbar;
